import {
    AsyncPipe,
    CurrencyPipe,
    NgTemplateOutlet,
} from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
} from "@angular/core";
import { CashierTypes } from "@Front-end/seed/models/payment";
import { UserDirective } from "@Front-end/seed/modules/user";
import { UserBonusListDirective } from "@Front-end/seed/modules/user-bonuses";
import { ListenToClickOutsideDirective } from "@Front-end/ui/directives/click-outside";
import { NgLetDirective } from "@Front-end/ui/directives/ng-let";
import { ModalOpenType } from "@Front-end/ui/models/modal";
import {
    ButtonV3KindDirective,
    ButtonV3PaletteDirective,
    ButtonV3SizeDirective,
} from "@Front-end/ui/modules/button-v3";
import { IconComponent } from "@Front-end/ui/modules/icon";
import { UiCurrencyPipe } from "@Front-end/ui/pipes";
import { TranslateModule } from "@ngx-translate/core";
import { environment } from "../../../../environments/environment";
import { CashierSources } from "../../../constants/cashier-source.constants";
import { BonusPercentPipe } from "../../../features/account-profile/pipes/bonus-percent.pipe";
import { CheckEventThemePipe } from "../../../pipes/check-event-theme.pipe";
import { AppPopupsService } from "../../../store/services/app-popups.service";
import { PictureComponent } from "../picture/picture.component";
import { SumBalancePipe } from "../pipes/pipes/sum-balance.pipe";

@Component({
    selector: "ls-profile-balance",
    templateUrl: "./profile-balance.component.html",
    styleUrls: ["./profile-balance.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        UserDirective,
        AsyncPipe,
        NgTemplateOutlet,
        TranslateModule,
        SumBalancePipe,
        ButtonV3KindDirective,
        ButtonV3PaletteDirective,
        ButtonV3SizeDirective,
        IconComponent,
        CheckEventThemePipe,
        ListenToClickOutsideDirective,
        UiCurrencyPipe,
        UserBonusListDirective,
        NgLetDirective,
        BonusPercentPipe,
        PictureComponent,
    ],
    providers: [CurrencyPipe],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        class: "profile-balance",
    },
})
export class ProfileBalanceComponent {
    constructor(
        private appPopupsService: AppPopupsService,
    ) {
    }

    public status: boolean = false;
    public minioUrl: string = environment.minioUrl;
    public eventTheme: string = environment.eventTheme;

    public openPaymentWindow(): void {
        this.appPopupsService.fireOpenCashier({
            source: CashierSources.HEADER_BALANCE,
            type: CashierTypes.DEPOSIT,
            openType: ModalOpenType.MANUAL,
        });
    }

    public toggleDropdown(): void {
        this.status = !this.status;
    }
}
